import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AppContainerService } from '@mydocma/app-container';
import { TreeOptions } from '@mydocma/component-library/src/lib/tree';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable } from 'rxjs';
import { StructureNode } from './structure.model';
import { StructureService } from './structure.service';

@UntilDestroy()
@Component({
  selector: 'mydocma-co-structure-left-pane',
  templateUrl: './structure-left-pane.component.html',
  styleUrls: ['./structure-left-pane.component.scss']
})
export class StructureLeftPaneComponent implements OnInit, OnDestroy {

  @Input() treeOptions: TreeOptions;

  public structuresTree: StructureNode[] = [] ;

  public isDataLoading$: Observable<boolean>;

  public refreshing$ = new BehaviorSubject<boolean>(false);

  public selectedStructureTreeNode: StructureNode;

  constructor(
    private readonly appContainerService: AppContainerService,
    private readonly structureService: StructureService,
  )
  {
    this.structureService.structuresTree$
    .pipe(untilDestroyed(this))
    .subscribe(strTree=>{
      if (!strTree ) {
        this.structuresTree = [];
      } else {
        this.selectedStructureTreeNode = this.structureService.selectedStructure;
        this.structuresTree = [strTree];
      }
    })
  }
  ngOnDestroy(): void {

  }

  async ngOnInit() {
  }

  public onCloseClick() {
    this.appContainerService.closeContentSideNav();
  }

  public onRefreshClick() {
    if (this.refreshing$.value) return;
    this.refreshing$.next(true);
    this.structureService.refreshStructures()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => this.refreshing$.next(false),
        error: () => this.refreshing$.next(false),
      });
  }

  public onStructureClick(structure) {
    this.structureService.selectedStructure = structure;
  }

}
